const data = [
  {
    id: Math.random() * 10,
    name: "Credit_Name",
    fields: [
      {
        id: Math.random() * 10,
        name: "Date",
        label: "Date",
        type: "Date",
        // restrictDateRange: true,
        Reference_field: "financialYear",
      },
      {
        id: Math.random() * 10,
        label: "Voucher No",
        name: "Ref_No",
        type: "text",
      },
      {
        id: Math.random() * 10,
        name: "Voucher_Series",
        label: "Book Code ",
        masterName: "Voucher_Series",
        type: "InputDropForQuery",
      },
      {
        id: Math.random() * 10,
        label: "Against Invoice No",
        name: "Against_Invoice_No",
        type: "text",
      },
      {
        id: Math.random() * 10,
        name: "Party",
        label: "Party Account",
        type: "InputDropForQuery",
        masterName: "Customer_Account_From_Account_Balance",
        variable: {
          accountType: ["Customer Account"],
        },
      },
      {
        id: Math.random() * 10,
        name: "RCM",
        label: "RCM",
        type: "inputdrop",
        dropdowndata: ["YES", "NO"],
        min: 0,
        max: Infinity,
        disabled: true,
        disableDependOn: {
          section: "Credit_Name",
          name: "Party",
          disableOn: "GST_Number",
          value: "NO",
        },
      },
    ],
  },
];

export const formField = {
  [Math.random() * 10]: [
    {
      id: Math.random() * 10,
      name: `Account_Name${Math.random() * 10}`,
      Input: true,
      type: "InputDropForQuery",

      value: "",
    },
    {
      id: Math.random() * 10,
      name: "Amount",
      Input: true,
      type: "Number",
      value: "",
    },
  ],
};

const fields1 = [
  {
    id: Math.random() * 10,
    name: "Account",
    Input: true,
    type: "InputDropForQuery",
    masterName: "General_Account",
    variable: {
      accountName: "Purchase",
      accountType: ["General Account"],
    },

    value: "",
    isRequired: true,
  },
  {
    id: Math.random() * 10,
    name: "Particular",
    Input: true,
    type: "text",
    value: "",
  },
  {
    id: Math.random() * 10,
    name: "Tax_Group",
    Reference_field: ["Party", ""],
    Input: true,
    type: "InputDropForQuery",
    masterName: "SalesInvoiceType",
    value: "",
  },
  {
    id: Math.random() * 10,
    name: "Tax_Rate",
    Input: true,
    type: "Number",
    value: "",
    disabled: true,
  },
  {
    id: Math.random() * 10,
    name: "HSN_Code",
    Input: true,
    type: "InputDropForQuery",
    masterName: "HSN_Code",
    value: "",
    isRequired: true,
  },

  {
    id: Math.random() * 10,
    name: "Amount",
    Input: true,
    type: "Number",
    value: "",
  },

  {
    id: Math.random() * 10,
    name: "Tax_Amount",
    Input: true,
    type: "Number",
    value: "",
    disabled: true,
  },
];

const InvoiceNumberConfig = [
  {
    id: Math.random() * 10,
    name: "Book_Code_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Voucher_Series",
        label: "Book Code ",
        masterName: "Voucher_Series",
        // dropdowndata: GetBookCodes,
        variable: {
          Voucher_Type: "Credit Note",
        },
        type: "InputDropForQuery",
      },
      {
        id: Math.random() * 10,
        name: "Bill_No",
        label: "Next Number",
        type: "Number",

        min: 5,
        max: 5,
      },
    ],
  },
];
const CreditNoteInvoiceNumberConfig = [
  {
    id: Math.random() * 10,
    name: "Config_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Default_Voucher_Series",
        label: "Default Voucher Series",
        type: "InputDropForQuery",
        masterName: "Voucher_Series",
        variable: {
          Voucher_Type: "Credit Note",
        },
        min: 0,
        max: Infinity,
        isRequired: true,
      },
    ],
  },
];

const initialHeaders = ["Account Name", "HSN", "Particular", "Amount", "Tax Rate", "Tax Amount"];
const initialHeaders1 = ["Account Name", "Particular", "Tax", "Tax Rate", "HSN", "Amount", "Tax Amount"];

export { data, fields1, initialHeaders1, InvoiceNumberConfig, CreditNoteInvoiceNumberConfig };
